const Avatar = () => {
    return (
        <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 36C0 16.128 16.128 0 36 0C55.872 0 72 16.128 72 36C72 55.872 55.872 72 36 72C16.128 72 0 55.872 0 36Z" fill="#B3B3B3"/>
            <path d="M47.445 33.42L42.84 47.25H29.16L24.555 33.42L36 25.41L47.445 33.42ZM21 32.25L27 50.25H45L51 32.25L36 21.75L21 32.25Z" fill="white"/>
        </svg>
    )
}

export default Avatar;